import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { Icon } from 'ui';
import { getAskTheExpertToggleTranslations } from 'selectors/learn/meta';
import AskTheExpertToggle from '../shared/AskTheExpertToggle';

const AskTheExpert = ({ i18n, currentUser, showSimpleVersion, className }) => {
  if (!currentUser.email) return null;

  return (
    <AskTheExpertToggle i18n={i18n.expertToggle}>
      {({ toggleModal }) => (
        <div
          className={cn(
            'LearnAskTheExpert',
            {
              'mt-4': showSimpleVersion,
            },
            className,
          )}
        >
          <span>{i18n.expert.question}</span>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid */}
          <a onClick={toggleModal}>
            <Icon name="chat_outline" className="LearnHeader-expertIcon" />
            {i18n.expert.action_button}
          </a>
        </div>
      )}
    </AskTheExpertToggle>
  );
};

const mapStateToProps = state => ({
  i18n: {
    expert: state.meta.i18n.learn.expert,
    expertToggle: getAskTheExpertToggleTranslations(state),
  },
  currentUser: {
    email: state.meta.currentUser.email,
  },
});

export default connect(mapStateToProps)(AskTheExpert);
